/**
 * Centralized logging utility
 * Handles logging based on environment and can be extended to send logs to external services
 */

const logger = {
  /**
   * Log informational messages (only in development)
   * @param {string} message - The message to log
   * @param {*} data - Additional data to log
   */
  log: (message, data = null) => {
    if (data !== null) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  },

  /**
   * Log error messages
   * @param {string} message - The error message
   * @param {*} error - The error object or additional data
   */
  error: (message, error = null) => {
    if (error !== null) {
      console.error(message, error);
    } else {
      console.error(message);
    }
    // In production, you would send errors to a logging service like:
    // - Sentry
    // - LogRocket
    // - Application Insights
    // - CloudWatch
    // Example:
    // if (!isDevelopment) {
    //   sendToLoggingService({ level: 'error', message, error });
    // }
  },

  /**
   * Log warning messages
   * @param {string} message - The warning message
   * @param {*} data - Additional data to log
   */
  warn: (message, data = null) => {
    if (data !== null) {
      console.warn(message, data);
    } else {
      console.warn(message);
    }
  },

  /**
   * Log debug messages (only in development)
   * @param {string} message - The debug message
   * @param {*} data - Additional data to log
   */
  debug: (message, data = null) => {
    if (data !== null) {
      console.debug(message, data);
    } else {
      console.debug(message);
    }
  }
};

export default logger;
